import { Component } from '@angular/core';

import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  bootstrapLinkedin,
  bootstrapTwitterX,
} from '@ng-icons/bootstrap-icons';

@Component({
  selector: 'app-portal-footer',
  imports: [NgIconComponent],
  providers: [
    provideIcons({
      bootstrapLinkedin,
      bootstrapTwitterX,
    }),
  ],
  templateUrl: './portal-footer.component.html',
})
export class PortalFooterComponent {}
